export default __webpack_public_path__ + "static/media/500-bg.a5f85704.gif";